import { createContext } from 'react';
import { usePageViewTracking } from "./usePageViewTracking/usePageViewTracking";
import { jsx as _jsx } from "react/jsx-runtime";
const BiTrackingContext = /*#__PURE__*/createContext({});
export const BiTrackingProvider = _ref => {
  let {
    children
  } = _ref;
  usePageViewTracking();
  return /*#__PURE__*/_jsx(BiTrackingContext.Provider, {
    value: {},
    children: children
  });
};